import { MapSources } from '../enums';
import { addLaneCenterLayer, addLaneLineHoverLayer, addLaneLineLayer } from './lanes';
import { addAreasPolygonFillLayer, addAreasPolygonLineLayer } from './areas';

/**
 * Creates a layer to display circles on the map for each Point and 'featureType' of 'laneCenter' in the given map source.
 * Adds the lane center layer to the map if it doesn't already exist
 * @param map Instance of your map
 * @param mapSource Name of the map source
 * @param isVisible Indicator if the map layer is visible
 */
export const addLaneDetailsCenterLayer = ({
    map,
    mapSource,
    isVisible,
}: {
    map: TrimbleMaps.Map;
    mapSource: MapSources;
    isVisible: boolean;
}): void => {
    addLaneCenterLayer({
        map,
        mapSource,
        isVisible,
    });
};

/**
 * Creates a layer to display lines on the map for each LineString and 'featureType' of 'laneLine' in the given map source.
 * Adds the lane line layer to the map if it doesn't already exist
 * @param map Instance of your map
 * @param mapSource Name of the map source
 * @param isVisible Indicator if the map layer is visible
 */
export const addLaneDetailsLineLayer = ({
    map,
    mapSource,
    isVisible,
}: {
    map: TrimbleMaps.Map;
    mapSource: MapSources;
    isVisible: boolean;
}): void => {
    addLaneLineLayer({
        map,
        mapSource,
        isVisible,
    });
};

/**
 * Creates a layer to display lines on the map for each LineString and 'featureType' of 'laneLine' in the given map source.
 * Adds the lane line layer to the map if it doesn't already exist
 * @param map Instance of your map
 * @param mapSource Name of the map source
 * @param isVisible Indicator if the map layer is visible
 */
export const addLaneDetailsLineHoverLayer = ({
    map,
    mapSource,
    isVisible,
}: {
    map: TrimbleMaps.Map;
    mapSource: MapSources;
    isVisible: boolean;
}): void => {
    addLaneLineHoverLayer({
        map,
        mapSource,
        isVisible,
    });
};

/**
 * Creates a layer to display polygons on the map for each 'featureType' of 'areaPolygon' in the given map source.
 * Adds the balance areas center layer to the map if it doesn't already exist
 * @param map Instance of your map
 * @param mapSource Name of the map source
 * @param isVisible Indicator if the map layer is visible
 */
export const addLaneDetailsAreasPolygonFillLayer = ({
    map,
    mapSource,
    isVisible,
}: {
    map: TrimbleMaps.Map;
    mapSource: MapSources;
    isVisible: boolean;
}): void => {
    addAreasPolygonFillLayer({
        map,
        mapSource,
        isVisible,
    });
};

/**
 * Creates a layer to display polygons on the map for each 'featureType' of 'areaPolygon' in the given map source.
 * Adds the balance areas center layer to the map if it doesn't already exist
 * @param map Instance of your map
 * @param mapSource Name of the map source
 * @param isVisible Indicator if the map layer is visible
 */
export const addLaneDetailsAreasPolygonLineLayer = ({
    map,
    mapSource,
    isVisible,
}: {
    map: TrimbleMaps.Map;
    mapSource: MapSources;
    isVisible: boolean;
}): void => {
    addAreasPolygonLineLayer({
        map,
        mapSource,
        isVisible,
    });
};
